import React, { useEffect, useState } from 'react';
import './LandingPage.css';

const LandingPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="home" className="landing-page">
      <div
        className="hero-background"
        role="img"
        aria-label="Chahine Cutlery - Jezzine Heritage"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${process.env.PUBLIC_URL}/images/Scene/Jezzine%20Entrance_Areal_Snow.webp)`
        }}
      ></div>
      
      <div className="hero-content">
        <div className={`hero-text ${isVisible ? 'visible' : ''}`}>
          <h1 className="brand-name">Chahine Cutlery</h1>
          <p className="heritage-tagline">
            Four generations of artisanal mastery,<br />
            crafting timeless elegance for discerning tables
          </p>
          <div className="hero-actions">
            <button 
              className="btn btn-gold"
              onClick={() => {
                const element = document.getElementById('featured');
                if (element) {
                  const headerHeight = 120; // Reduced offset to properly show section headers
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                  });
                }
              }}
            >
              Discover Collection
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingPage;